module.exports = __webpack_public_path__ + "img/pagbank-hero.6cb8b55e.png";